import { useAuth } from '../context/AuthContext';
import { GoogleLogin } from '@react-oauth/google';
import { ReactComponent as LoginIllustration } from '../assets/lg-lap.svg'; 

export default function LoginPage() {
  const { login } = useAuth();

  return (
    <div className="login-page-container">
      {/* Cột trái - Trình bày và thương hiệu */}
      <div className="login-showcase">
        <div className="showcase-content">
          <div className="logo">
            <a href="/">LAPVocab</a>
          </div>
          <h1>Master vocabulary like an expert</h1>
          <p>Expand your vocabulary the smart and organized way.</p>
          <LoginIllustration className="illustration" />
        </div>
      </div>

      {/* Cột phải - Form đăng nhập */}
      <div className="login-form-area">
        <div className="login-box">
          <h2>Get started now</h2>
          <p>Continue with your Google account.</p>
          <GoogleLogin
            onSuccess={login}
            onError={() => {
              console.log('Login Failed');
            }}
            theme="filled_blue"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>
      </div>
    </div>
  );
}